import { fromHex, toHex } from "./bytes.js";
import { randomBytes } from "./crypto.js";
export const STORE = {
    seed: "konekt:seed",
    keys: "konekt:keys",
    session: "konekt:session",
};
/**
 * Creates non-persistent storage backed by a new in-memory map.
 *
 * Each call returns an isolated store. Data disappears when the object is discarded.
 */
export function memoryStorage() {
    const m = new Map();
    return {
        getItem: async (k) => m.get(k) ?? null,
        setItem: async (k, v) => void m.set(k, v),
        removeItem: async (k) => void m.delete(k),
    };
}
export function defaultStorage() {
    if (typeof localStorage === "undefined")
        return memoryStorage();
    return {
        getItem: async (k) => localStorage.getItem(k),
        setItem: async (k, v) => localStorage.setItem(k, v),
        removeItem: async (k) => localStorage.removeItem(k),
    };
}
export async function loadSeed(storage) {
    const hex = await storage.getItem(STORE.seed);
    if (hex)
        return fromHex(hex);
    const seed = randomBytes(32);
    await storage.setItem(STORE.seed, toHex(seed));
    return seed;
}
//# sourceMappingURL=storage.js.map